import { UpdateEscrowSettingsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateUpdateEscrowSettings = makeValidator({
  FieldParser: UpdateEscrowSettingsRow,
});
